import React, { useReducer } from "react";
import { Tabel, DropDown, Badge, DropDownMenu, Modal } from "../core";
import { reducer, initialState } from "../hooks/modalReducer";

import { Link } from "react-router-dom";

import { Menu } from "antd";
import EmptyBeamDeliver from "./EmptyBeamDeliver";
import BeamReceived from "./BeamReceived";

const invoice = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    width: 150,
  },
  {
    title: "Tar/BackBeam",
    dataIndex: "tarbackbeam",
    key: "tarbackbeam",
    width: 150,
  },
  {
    title: "Empty Beam Delivery",
    dataIndex: "empty_beam_delivery",
    key: "empty_beam_delivery",
    width: 150,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text) => <Badge status={text} text={text}></Badge>,
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];

const SizingProgram = ({ SizingProgramData, pagination, ...props }) => {
  return (
    <Tabel
      {...props}
      pagination={pagination}
      columns={invoice}
      data={SizingProgramData}
    />
  );
};
const MenuCompo = (props) => {
  const { contarctNumber } = props.record;
  const [state, dispatch] = useReducer(reducer, initialState);
  function clickHandler(params) {
    dispatch({
      type: "MODAL_VIEW",
      payload: { flag: true, modal_name: params },
    });
  }
  const onCreate = (values) => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };

  return (
    <div>
      <DropDownMenu>
        <Menu.Item
          className="menu--item"
          key="complete"
          onClick={() => clickHandler("beam deliverd")}
        >
          Beams Deliverd
        </Menu.Item>
        <Menu.Item
          className="menu--item"
          key="dispatch"
          onClick={() => clickHandler("beam received")}
        >
          Beam Received
        </Menu.Item>
        <Menu.Item className="menu--item" key="return">
          <Link to={`/contract-inner/${contarctNumber}`}>Completed</Link>
        </Menu.Item>
        <Menu.Item className="menu--item" key="delete">
          <Link to={`/contract-inner/${contarctNumber}`}>Delete</Link>
        </Menu.Item>
        <Menu.Item className="menu--item" key="view">
          <Link to={`/program-details/${props.record._id || props.record.add_program_id}`}>
            View
          </Link>
        </Menu.Item>
        <Menu.Item className="menu--item" key="edit">
          <Link to={`/contract-inner/${contarctNumber}`}>Edit</Link>
        </Menu.Item>
      </DropDownMenu>

      <Modal
        closable={false}
        visible={state.visible}
        onCreate={onCreate}
        footer={false}
        maxwidth="589px"
        onCancel={() => dispatch({ type: "MODAL_VIEW", payload: false })}
        tittle={
          state.modal_name === "beam deliverd"
            ? "Empty Beam Delivery"
            : "Beam Received"
        }
      >
        {state.modal_name === "beam deliverd" ? (
          <EmptyBeamDeliver onCreate={onCreate} />
        ) : (
          <BeamReceived onCreate={onCreate} />
        )}
      </Modal>
    </div>
  );
};
export default SizingProgram;
